import { UserSession } from "@app/admin/user-sessions/apiModels";
import ServiceBase from "@app/shared/serviceBase";

class UserSessionService extends ServiceBase {
  private authenticationApiEndpoint = `${this.authenticationEndpoint}/api`;

  public async get(): Promise<UserSession[]> {
    return await this.makeGet<UserSession[]>("/account/user-sessions", null, this.authenticationApiEndpoint);
  }
  public async patch(sessions: UserSession[]): Promise<void> {
    return await this.makePatch("/account/user-sessions", sessions, false, this.authenticationApiEndpoint);
  }
}

export {
  UserSessionService,
};
